import React from "react";

type ProductionMigrationBannerProps = {
  onOpenMigration: () => void;
};

//const LAUNCH_DATE_LABEL = "Thursday, 7 May 2026";

export default function ProductionMigrationBanner({ onOpenMigration }: ProductionMigrationBannerProps) {
  return (
    <div
      role="region"
      aria-label="Production launch and account setup notice"
      className="w-full border-b border-brand-blue/20 bg-bg-blue px-4 py-3 text-base text-dark-black lg:px-8"
    >
      <div className="mx-auto flex max-w-[1200px] justify-center flex-col gap-2 sm:flex-row sm:items-center  sm:gap-4">
        <p className="min-w-0 leading-relaxed">
        Trouble signing in? Use “Forgot Password” or fill out this form for assistance.
        </p>
        <button
          type="button"
          onClick={onOpenMigration}
          className="shrink-0 text-left text-base font-semibold text-brand-blue underline underline-offset-2 hover:text-dark-black sm:text-right"
        >
          Complete setup
        </button>
      </div>
    </div>
  );
}
